import './style.css'
import { useTranslation } from "react-i18next";
import { AppProps } from "../../App"
import Footer from "../../components/FooterLanding";
import Navbar from "../../components/Navbar"
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from 'react';
import CodeDisplay from '../../components/CodeDisplay';
import { HiOutlineUserCircle } from 'react-icons/hi';
import { TbDatabaseSearch, TbFileLambda, TbFolderUp } from 'react-icons/tb';

// landing page component
const Landing = (props: AppProps) => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);
  const [urls, setUrls] = useState(['images/landing/auth-example.png', 'images/landing/database-example.png', 'images/landing/function-example.png']);
  const [imageIndex, setImageIndex] = useState(0);
  const codes = {
    setup: `const { ProjectManager } = require('tranfoo.js');\n\nasync function main(event) {\n\tconst manager = new ProjectManager({ projectId: process.env.PROJECT_ID, apiKey: process.env.API_KEY });\n\n\tawait manager.database.createItem({\n\t\ttableName: 'customers',\n\t\titem: {\n\t\t\tid: 'customer1',\n\t\t\tname: 'Aiden',\n\t\t\tphoneNumber: '123-456-7890'\n\t\t}\n\t});\n\n\treturn { message: 'Customer created successfully.' };\n}`,
  };

  // use interval
  useEffect(() => {
    if (!containerRef.current) return;
    const interval = setInterval(() => {
      setImageIndex((prevIndex) => (prevIndex + 1) % urls.length);
    }, 3200);
    return () => clearInterval(interval);
  }, [urls]);

  return (
    <>
      <Navbar {...props} />
      <main className="flex flex-col items-center *:w-full">
        <div className='flex flex-col items-center py-16 md:pt-40'>
          {/* headline */}
          <div className="text-4xl md:text-5xl text-center px-4 max-w-3xl" style={{ lineHeight: 1.2 }}>{t('home.headline')}</div>
          {/* subheadline */}
          <div className="text-lg md:text-xl p-4 mt-4 md:mt-8 font-light text-center">{t('home.subheadline')}</div>
          {/* call to action */}
          <div className='flex flex-col sm:flex-row gap-8 mt-4 md:mt-8'>
            <button onClick={() => navigate('/signin')} className="text-sm text-white bg-primary py-3 px-12 rounded-lg">{t('home.get-started')}</button>
            <button onClick={() => window.open('https://cal.com/junweilin')} className='font-bold text-sm border py-3 px-8 rounded-lg'>{t('menu.book-demo')}</button>
          </div>
        </div>
        {/* features */}
        <div className='px-8 md:px-16 py-8 flex flex-col items-center'>
          <div className='flex flex-col md:flex-row w-full max-w-6xl'>
            {/* text */}
            <div className='w-full md:w-2/5'>
              <div className='flex flex-col items-center md:items-start my-16'>
                <div className='my-4'><HiOutlineUserCircle className='text-gray-400 text-3xl' /></div>
                <div className='text-xl md:text-2xl'>{t('home.features.auth')}</div>
                <div className='font-light w-3/4 my-6 text-center md:text-start'>{t('home.features.auth-description')}</div>
              </div>
              <div className='flex flex-col items-center md:items-start my-16'>
                <div className='my-4'><TbDatabaseSearch className='text-gray-400 text-3xl' /></div>
                <div className='text-xl md:text-2xl'>{t('home.features.database')}</div>
                <div className='font-light w-3/4 my-6 text-center md:text-start'>{t('home.features.database-description')}</div>
              </div>
              <div className='flex flex-col items-center md:items-start my-16'>
                <div className='my-4'><TbFileLambda className='text-gray-400 text-3xl' /></div>
                <div className='text-xl md:text-2xl'>{t('home.features.function')}</div>
                <div className='font-light w-3/4 my-6 text-center md:text-start'>{t('home.features.function-description')}</div>
              </div>
            </div>
            {/* image */}
            <div className='md:sticky bottom-0 md:flex-1 px-4'>
              <div className='w-full h-full'>
                <div className='w-full md:h-menu-md md:sticky top-16 flex items-center justify-center'>
                  <div className='w-full aspect-[128/67] rounded-xl overflow-hidden' style={{ boxShadow: '0px 0px 48px 4px #0001' }}>
                    <div ref={containerRef} className='animate relative h-full w-full flex overflow-auto no-scroller'>
                      {/* {urls.map((url, i) => (
                        <div className='h-full w-full absolute' style={{ left: `${i * 100}%` }}>
                          <img src={url} className='w-full h-full object-cover' alt='' />
                        </div>
                        ))} */}
                      <div className='h-full w-full absolute' style={{ left: `0%` }}>
                        <img src={urls[imageIndex]} className='w-full h-full object-cover' alt='' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* code examples */}
        <div className='flex flex-col md:flex-row items-start w-full px-8 md:px-16 my-16 max-w-6xl'>
          {/* text */}
          <div className='w-full md:w-2/5 my-8'>
            <div className='text-2xl md:text-3xl w-4/5'>{t('home.examples.title')}</div>
            <div className='font-light my-6 text-start w-4/5'>{t('home.examples.statement')}</div>
            <button onClick={() => window.open('/docs')} className="mt-8 text-sm text-white bg-primary py-2 px-8 rounded-lg">{t('home.examples.view-docs')}</button>
          </div>
          {/* code */}
          <div className='w-full md:w-3/5'>
            <div className='w-full'>
              <CodeDisplay bgColor='#f4f8fb' title={t('home.examples.code-title')} content={codes.setup} language='javascript' textSize='small' />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  )
}

export default Landing;